declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export const trackPageView = (path: string) => {
  const measurementId = 'G-PEQ77C31LK';
  
  if (typeof window.gtag === 'function') {
    window.gtag('config', measurementId, {
      page_path: path,
    });
  } else {
    // Wait for gtag to be available (SPA case)
    const checkGtag = setInterval(() => {
      if (typeof window.gtag === 'function') {
        window.gtag('config', measurementId, {
          page_path: path,
        });
        clearInterval(checkGtag);
      }
    }, 100);
    
    // Timeout after 5 seconds
    setTimeout(() => clearInterval(checkGtag), 5000);
  }
};

export const trackEvent = (eventName: string, eventParams?: Record<string, any>) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, eventParams);
  }
};

